<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Añadir" : "Eliminar" }} datos fiscales</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-input label="Nombre o Razón Social" v-model="dataName" class="mt-5 w-full" name="item-name" />

        <vs-input label="RFC" @input="dataRfc = $event.toUpperCase()" v-model="dataRfc" class="mt-5 w-full" name="item-rfc" min="12" max="13" />

        <vs-input label="Código postal (Domicilio Fiscal)" v-model="dataLocaltionCode" class="mt-5 w-full" name="item-location-code" min="5" max="5" />

        <br>
        <label class="vs-input--label">Régimen Fiscal</label>
        <v-select :options="regimenFiscalList" v-model="dataRegimenFiscal" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>

        <br>
        <label class="vs-input--label">Uso de CFDI</label>
        <v-select :options="cfdiList" v-model="dataCfdiUse" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>

        <ul class="demo-alignment mt-2 w-full">
          <li>
            <vs-checkbox v-model="dataDefault">Hacer predeterminado</vs-checkbox>
          </li>
        </ul>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      dataId: null,
      dataName: '',
      dataRfc: '',
      dataCfdiUse: null,
      dataLocaltionCode: '',
      dataRegimenFiscal: '',
      dataDefault: false,
      unmaskedRfc: '',
      cfdiList: [
        {id: 'G01', label: 'G01 - Adquisición de mercancias'},
        {id: 'G02', label: 'G02 - Devoluciones, descuentos o bonificaciones'},
        {id: 'G03', label: 'G03 - Gastos en general'},
        {id: 'I01', label: 'I01 - Construcciones'},
        {id: 'I02', label: 'I02 - Mobilario y equipo de oficina por inversiones'},
        {id: 'I03', label: 'I03 - Equipo de transporte'},
        {id: 'I04', label: 'I04 - Equipo de computo y accesorios'},
        {id: 'I05', label: 'I05 - Dados, troqueles, moldes, matrices y herramental'},
        {id: 'I06', label: 'I06 - Comunicaciones telefónicas'},
        {id: 'I07', label: 'I07 - Comunicaciones satelitales'},
        {id: 'I08', label: 'I08 - Otra maquinaria y equipo'},
        {id: 'D01', label: 'D01 - Honorarios médicos, dentales y gastos hospitalarios.'},
        {id: 'D02', label: 'D02 - Gastos médicos por incapacidad o discapacidad'},
        {id: 'D03', label: 'D03 - Gastos funerales'},
        {id: 'D04', label: 'D04 - Donativos'},
        {id: 'D06', label: 'D06 - Aportaciones voluntarias al SAR'},
        {id: 'D07', label: 'D07 - Primas por seguros de gastos médicos'},
        {id: 'D08', label: 'D08 - Gastos de transportación escolar obligatoria'},
        {id: 'D09', label: 'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.'},
        {id: 'D10', label: 'D10 - Pagos por servicios educativos (colegiaturas)'},
        {id: 'P01', label: 'P01 - Por definir'}
      ],
      regimenFiscalList: [
        {id: '601', label: '601 - General de Ley Personas Morales'},
        {id: '603', label: '603 - Personas Morales con Fines no Lucrativos'},
        {id: '605', label: '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios'},
        {id: '606', label: '606 - Arrendamiento'},
        {id: '607', label: '607 - Régimen de Enajenación o Adquisición de Bienes'},
        {id: '608', label: '608 - Demás ingresos'},
        {id: '610', label: '610 - Residentes en el Extranjero sin Establecimiento Permanente en México'},
        {id: '611', label: '611 - Ingresos por Dividendos (socios y accionistas)'},
        {id: '612', label: '612 - Personas Físicas con Actividades Empresariales y Profesionales'},
        {id: '614', label: '614 - Ingresos por intereses'},
        {id: '615', label: '615 - Régimen de los ingresos por obtención de premios'},
        {id: '616', label: '616 - Sin obligaciones fiscales'},
        {id: '620', label: '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos'},
        {id: '621', label: '621 - Incorporación Fiscal'},
        {id: '622', label: '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras'},
        {id: '623', label: '623 - Opcional para Grupos de Sociedades'},
        {id: '624', label: '624 - Coordinados'},
        {id: '625', label: '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'},
        {id: '626', label: '626 - Régimen Simplificado de Confianza'},
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, company, rfc, cfdi_use, location_code, regimen_fiscal, selected } = JSON.parse(JSON.stringify(this.data))
        let selectedUseCfdi = this.cfdiList.find(item => item.id === cfdi_use);
        let selectedRegimenFiscal = this.regimenFiscalList.find(item => item.id === regimen_fiscal);
        this.dataId = id
        this.dataName = company
        this.dataRfc = rfc
        this.dataCfdiUse = selectedUseCfdi;
        this.dataLocaltionCode = location_code;
        this.dataRegimenFiscal = selectedRegimenFiscal;
        this.dataDefault = selected;
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    getRfcUnmasked(e) {
      this.unmaskedRfc = e.target.unmaskedValue;
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataRfc = ''
      this.dataLocaltionCode = ''
      this.dataRegimenFiscal = ''
      this.dataCfdiUse = null;
      this.dataDefault = false;
    },
    submitData () {
      if (this.dataId !== null) {
        this.$store.dispatch('taxData/updateTaxData', {
          taxData: {
            id: this.dataId,
            company: this.dataName,
            rfc: this.dataRfc,
            use_cfdi: this.dataCfdiUse.id,
            location_code: this.dataLocaltionCode,
            regimen_fiscal: this.dataRegimenFiscal.id,
            default: this.dataDefault,
          }
        })
          .then(() => {
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch(err => { console.error(err) })
      } else {
        this.$store.dispatch('taxData/createTaxData', {
          taxData: {
            company: this.dataName,
            rfc: this.dataRfc,
            use_cfdi: this.dataCfdiUse.id,
            location_code: this.dataLocaltionCode,
            regimen_fiscal: this.dataRegimenFiscal.id,
            default: this.dataDefault,
          }
        })
          .then(() => {
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch(err => { console.error(err) })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.vs__dropdown-option{
  max-width: 100px!important;
}
.vs__dropdown-menu{
  max-width: 100px!important;
}
</style>
